import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  Input,
  Output,
} from '@angular/core';

import { FormControl, Validators } from '@angular/forms';

import { Subject } from 'rxjs';
import { debounceTime, filter, takeUntil } from 'rxjs/operators';

import { Account } from '../../models';

import { AbstractControl } from '@angular/forms';

export const isSpace = (control: AbstractControl) => {
  const ret = (control.value || '').match(/\s/g);
  return ret && ret.length > 0 ? { whitespace: true } : null;
};

@Component({
  selector: 'apsis-back-office-account-domain-add',
  templateUrl: './account-domain-add.component.html',
  styleUrls: ['./account-domain-add.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountDomainAddComponent implements OnDestroy {
  @Input() accounts: Account[];
  @Input() set selectedAccount(selectedAccount: string) {
    if (selectedAccount) {
      this.accountDomainControl.setValue(selectedAccount, { emitEvent: false });
      this.accountDomainNameControl.setValue('', { emitEvent: false });
    }
  }
  @Input() set selectedAccountDomainName(selectedAccountDomainName: string) {
    if (selectedAccountDomainName) {
      this.accountDomainNameControl.setValue(selectedAccountDomainName, {
        emitEvent: false,
      });
    }
  }
  @Input() set disableAccounts(_: boolean) {
    this.accountDomainControl.disable();
  }
  @Output() selectAccount = new EventEmitter<string>();
  @Output() selectAccountDomainName = new EventEmitter<string>();

  public accountDomainControl: FormControl;
  public accountDomainNameControl: FormControl;

  private readonly destroy$ = new Subject();

  constructor() {
    this.accountDomainControl = new FormControl('', [Validators.required]);
    this.accountDomainNameControl = new FormControl('', [isSpace]);
    this.accountDomainNameControl.valueChanges
      .pipe(
        debounceTime(100),
        filter(() => !!this.accountDomainControl.value),
        takeUntil(this.destroy$),
      )
      .subscribe((value) => {
        this.selectAccountDomainName.emit(value);
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  selectEvent(account: Account) {
    this.selectAccount.emit(account.id);
  }
}
